import { WEB_TYPES } from '../Core/Redux/SettingsRedux'
import { cookie } from 'devx-js-utilities'
import Api from '../Services/SuriApi'

export function getCurrentWebType(domain) {
  if (domain.includes('sro')) return WEB_TYPES.SRO
  else if (domain.includes('sur')) return WEB_TYPES.SUR
  else if (domain.includes('pov')) return WEB_TYPES.POV
  else if (domain.includes('renomia')) return WEB_TYPES.REN
  else return WEB_TYPES.SUR
}

export function saveUtmParams(trackingParams) {
  let utmSource = cookie.readCookie('utm_source')
  let utmMedium = cookie.readCookie('utm_medium')
  let utmCampaign = cookie.readCookie('utm_campaign')
  let utmContent = cookie.readCookie('utm_content')
  let utmTerm = cookie.readCookie('utm_term')
  let googleCookie = cookie.readCookie('_ga')
  let googleClientId =
    typeof googleCookie === 'string' && googleCookie.split('.').length > 2 && googleCookie.split('.').slice(2).join('.')

  if (trackingParams) {
    if (trackingParams.googleClientId || trackingParams.googleclientid) {
      googleClientId = trackingParams.googleClientId || trackingParams.googleclientid
    }
    if (trackingParams.properties && trackingParams.properties['utm-source']) {
      utmSource = trackingParams.properties['utm-source']
      utmMedium = trackingParams.properties['utm-medium']
      utmCampaign = trackingParams.properties['utm-campaign']
      utmContent = trackingParams.properties['utm-content']
      utmTerm = trackingParams.properties['utm-term']
    }
  }

  if (googleClientId) {
    Api.setHeader('X-Tracking-googleClientId', googleClientId)
  }

  if (utmSource) {
    Api.setHeader('X-Tracking-utm-source', utmSource)
    if (utmMedium) {
      Api.setHeader('X-Tracking-utm-medium', utmMedium)
    }
    if (utmCampaign) {
      Api.setHeader('X-Tracking-utm-campaign', utmCampaign)
    }
    if (utmContent) {
      Api.setHeader('X-Tracking-utm-content', utmContent)
    }
    if (utmTerm) {
      Api.setHeader('X-Tracking-utm-term', utmTerm)
    }
  }
}
